const fixture = {};

export default fixture;
